import { ServiceRequest } from "../../api/ServiceRequest";

export class UserRequest extends ServiceRequest {
  roleId?: string;
  email?: string;
  username?: string;
  status?: string;
  mobile?: string;

  constructor(init?: Partial<UserRequest>) {
    super(init); // passes common props
    Object.assign(this, init); // assigns Fuel-specific props
  }

  // Getters
  getRoleId(): string | undefined {
    return this.roleId;
  }
  getEmail(): string | undefined {
    return this.email;
  }
  getUsername(): string | undefined {
    return this.username;
  }
  getStatus(): string | undefined {
    return this.status;
  }
  getMobile(): string | undefined {
    return this.mobile;
  }

  // Setters
  setRoleId(value: string | undefined): void {
    this.roleId = value;
  }
  setEmail(value: string | undefined): void {
    this.email = value;
  }
  setUsername(value: string | undefined): void {
    this.username = value;
  }
  setStatus(value: string | undefined): void {
    this.status = value;
  }
  setMobile(value: string | undefined): void {
    this.mobile = value;
  }
}
